import { AutorizationService } from 'src/app/api/autorization.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError  } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private authService: AutorizationService,  public snackBar: MatSnackBar) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(err => {
      if ([401].indexOf(err.status) !== -1){
        this.authService.logout();
      } 
         this.openSnackBarError(err.error.message)
         const error = err.error.message || err.statusText;
      return throwError(error);
    }));
  }


  openSnackBarError(message: string ) {
    this.snackBar.open(message, "X", {
      panelClass: ['blue-snackbar'],
      duration: 20000,
    });
  }
}